import React from "react";
import ToshibaIcon from '../assets/icons/toshiba-01.svg';

const appVersion = window && window.config && window.config.VERSION; //for dev

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Get the current year
  return (
    <footer className="footer-div ph-16 item-center flex">
      <span className="dashboard_footer_txt">
        {currentYear} © Toshiba Global Commerce Solutions
      </span>
      <span className="dashboard_footer_txt pl_10px"> Version: {appVersion}</span>
      <img
        src={ToshibaIcon}
        className="dashboard_footer_img ml-auto"
        alt="toshiba global commerce solutions"
      />
    </footer>
  );
};

export default Footer;
